// src/plugins/posthog.js
import posthog from 'posthog-js';
export function setupPostHog() {
  posthog.init('phc_mCZGmwqWOsQmJoKWxPCI3auhhDfOVKTTHo7cEjjghyi', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-11-30',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
  })

  window.posthog = posthog;
}
